import { useFeatureFlagTableDataRetrieveSuspense } from "gen/endpoints/feature-flag-table-data/feature-flag-table-data";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { GetLinkInfoForRowFn } from "shared/components/table/data/DataTableTypes";
import { rootRoute } from "shared/navigation/Routes";

export const InternalFeatureFlagsPage: React.FC = () => {
  const { t } = useTranslation(["internal"]);
  const { data: tableData } = useFeatureFlagTableDataRetrieveSuspense();

  const getLinkInfoForRow = useCallback<GetLinkInfoForRowFn>(
    ({ row }) =>
      row.data?.metadata?.type === "id_row"
        ? {
            type: "generic",
            to: rootRoute({})
              .internal({})
              .featureFlag({ featureFlagId: row.data.metadata.id })
              .details({}).$,
          }
        : undefined,
    [],
  );

  return (
    <PageContent isFullHeight={true}>
      <PageBody>
        <PageHeader title={t("internal:featureFlags")} />
        <TableBox>
          <TableBoxHeader>
            <TableBoxTitle>{t("internal:featureFlags")}</TableBoxTitle>
            <DataTableBoxActions />
          </TableBoxHeader>
          <TableBoxBody>
            <DataTable data={tableData} getLinkInfoForRow={getLinkInfoForRow} />
          </TableBoxBody>
        </TableBox>
      </PageBody>
    </PageContent>
  );
};
